// removed by extract-text-webpack-plugin
module.exports = {"main":"segment-tooltip-main--nq3Ya","distance":"segment-tooltip-distance--3PHqr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/CreateSegment/PathSuggestionTooltip/segment-tooltip.scss
// module id = UitP
// module chunks = 4